<template>
  <hy-input v-if="!isReadOnly" type="text" v-model="attribute.ref.value" :maxlength="maxLength" v-bind="$attrs" :placeholder="placeholder"/>
  <span v-else-if="attribute.ref.value" v-bind="$attrs">{{attribute.ref.value}}</span>
  <span v-else v-bind="$attrs">&ZeroWidthSpace;{{ nullDisplayValue }}</span> <!-- wenn attribute ungesetzt ist stelle Whitespace dar, damit regulärere Platz reserviert wird-->
</template>

<script>
import { computed, ref } from "vue";
import Attribute from "../../xmlrdb-data/Attribute"
import HyInput from "../../basic-components/HyInput.vue";
export default {
  inheritAttrs: false,
  name: "textField",
  props: {
    attribute: Attribute,
    isReadOnly: Boolean,
    placeholder: String,
    nullDisplayValue: { type: String, default: "" },
  },
  // Steuert in der Attribute - Komponente ob das erzeugte Label als Click-Label für die Input-Komponente agieren soll
  // clickableAttributeLabel: true, 
  clickableContainer: true,
  components: {
    HyInput
  },
  setup(props) {

    return {
      //attributex : props.attribute
      maxLength: computed(()=>{ 
        return props.attribute.metadata.maxLength();
      })
    }
  }
}

</script>

<style scoped>
</style>